export default "__VITE_ASSET__BhyxwoMa__"